import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function Button({ style, className, children, onClick, type, disabled }) {
  return (
    <button
      style={style}
      className={`btn ${type} ${className} ${disabled && 'disabled'}`}
      onClick={onClick}
    >{children}</button>
  );
}

Button.propTypes = {
  style: PropTypes.shape(),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['', 'primary', 'simple']),
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  type: '',
  className: '',
  style: {},
  disabled: false,
};

